import styled from '@emotion/styled'

export const HighlightContainer = styled.span`
  font-weight: 600;
`

export const ChangeRow = styled.div`
  //   margin: 10px 0;
  display: flex;
  flex-wrap: wrap;
  //   border: 1px solid ${props => props.theme.grey3};
  // padding: 0 5px;

  &.does-not-exist {
    opacity: 0.5;
  }
`

export const ChangeDate = styled.div`
  font-size: 0.75rem;
  font-weight: bold;
  margin-bottom: 10px;
`

export const ChangeMessage = styled.div`
  margin: 1rem 0;
`

export const ChangeDetails = styled.div``

export const ChangeField = styled.div`
  background-color: ${props => props.theme.grey3};
  padding: 8px 14px;
  margin-bottom: 0.5rem;
`

export const ChangeFieldName = styled.h4`
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 3px;
  margin-right: 10px;
  // width: 100%;
  display: inline-block;
`

export const ChangeValue = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  // width: 100%;
  display: inline-block;

  &.hasMultipleUpdates {
    width: 100%;

    // &:first-of-type {
    //   margin-top: 10px;
    // }
  }
`
export const PreviousValue = styled.span`
  background-color: #f9b3b4;
  padding: 0 5px;
  margin: 0 5px 0 0;
  position: relative;
  display: inline-block;
`
export const NewValue = styled.span`
  background-color: #b5e39e;
  padding: 0 5px;
  margin: 0 5px 0 0;
  position: relative;
  display: inline-block;
`
